"use client";

import { withFallback } from "../with-fallback";

export const VerifyElement = withFallback({
	displayName: "VerifyElement",
	type: "verify-element",
} as const);
